import { render, staticRenderFns } from "./sourcesListComponent.vue?vue&type=template&id=786fc1f9"
import script from "./sourcesListComponent.vue?vue&type=script&lang=js"
export * from "./sourcesListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports